$(function(){
	var knowledgeAnimation = $('.page-knowledge .container-row a');

	function makeSqaure() {
		$('.js-square').each(function(){
			var elemWidth = $(this).width();
			if($(window).width() < 993) {
				$(this).css({"height": elemWidth})
			} else {
				$(this).css({"height": "50%"})
			}
		});
	};
	makeSqaure();

	$(window).resize(function(){
		makeSqaure();
	})

	knowledgeAnimation.mouseenter(function() {
		$(this).find('#corporateSVG #hook1')
			.velocity({ 'stroke-dashoffset': '1200' }, 0)
	      	.velocity({ 'stroke-dashoffset': 0 }, 2000, [0.42,0,0,1])
	    $(this).find('#corporateSVG #hook2')
			.velocity({ 'stroke-dashoffset': '1200' }, 0)
	      	.velocity({ 'stroke-dashoffset': 0 }, 2000, [0.42,0,0,1])


	   	$(this).find('#cybercrimeSVG #line1')
			.velocity({
				'x2': '170',
				 }, 0)
	      	.velocity({
	      		'x2': '273.3',
	      	}, {duration:800}, [0.42,0,0,1])

	    $(this).find('#cybercrimeSVG #line2')
			.velocity({
				'x2': '170',
				 }, 0)
	      	.velocity({
	      		'x2': '273.3',
	      	}, {duration:800, delay:50}, [0.42,0,0,1])

	    $(this).find('#cybercrimeSVG #line3')
			.velocity({
				'x2': '170',
				 }, 0)
	      	.velocity({
	      		'x2': '273.3',
	      	}, {duration:800, delay:100}, [0.42,0,0,1])


	    $(this).find('#cybercrimeSVG-en #line1')
			.velocity({
				'x2': '193',
				 }, 0)
	      	.velocity({
	      		'x2': '247.8',
	      	}, {duration:800}, [0.42,0,0,1])

	    $(this).find('#cybercrimeSVG-en #line2')
			.velocity({
				'x2': '193',
				 }, 0)
	      	.velocity({
	      		'x2': '247.8',
	      	}, {duration:800, delay:100}, [0.42,0,0,1])

	    $(this).find('#cybercrimeSVG-en #line3')
			.velocity({
				'x2': '193',
				 }, 0)
	      	.velocity({
	      		'x2': '247.8',
	      	}, {duration:800, delay:50}, [0.42,0,0,1])


	    $(this).find('#socialSVG #rect1')
			.velocity({
				'width': '0',
				'x': '424'
				 }, 0)
	      	.velocity({
	      		'width': '172.3',
	      		'x': '338'
	      	}, 1200, [0.42,0,0,1])
	    $(this).find('#socialSVG #rect2')
			.velocity({
				'width': '0',
				'x': '424'
			}, 0)
	      	.velocity({
	      		'width': '172.3',
	      		'x': '338'
	      	}, 1400, [0.42,0,0,1])
	    $(this).find('#socialSVG #rect3')
			.velocity({
				'height': '0',
				'y': '447'
			}, 0)
	      	.velocity({
	      		'height': '172.3',
	      		'y': '327'
	      	}, 1600, [0.42,0,0,1])


			$(this).find('#socialSVG-en #rect1')
				.velocity({
					'width': '0',
					 }, 0)
		      	.velocity({
		      		'width': '255.1',
		      	}, 1200, [0.42,0,0,1])
		    $(this).find('#socialSVG-en #rect2')
				.velocity({
					'width': '0',
					'x': '590'
				}, 0)
		      	.velocity({
		      		'width': '378.7',
		      		'x': '210.2'
		      	}, 1400, [0.42,0,0,1])

	    $(this).find('#techonlogiesSVG .path-to-animate')
		.velocity({ 'stroke-dashoffset': '160' }, 0)

	    $(this).find('#techonlogiesSVG #path1')
	    .velocity({ 'stroke-dashoffset': 0 }, {duration:1200, delay:200}, [0.42,0,0,1])

	    $(this).find('#techonlogiesSVG #path2')
	    .velocity({ 'stroke-dashoffset': 0 }, 1600, [0.42,0,0,1])

	    $(this).find('#techonlogiesSVG #path3')
	    .velocity({ 'stroke-dashoffset': 0 }, 1000, [0.42,0,0,1])


	    $(this).find('#santeSVG .top').each(function(i) {
	    	var delay = i * 70;
	    	$(this).velocity({
	    		translateY: "-30px"
	    	}, {duration:500, delay: delay}, [0.42,0,0,1])
	    });
	    $(this).find('#santeSVG .bottom').each(function(i) {
	    	var delay = i * 70;
	    	$(this).velocity({
	    		translateY: "30px"
	    	}, {duration:500, delay: delay}, [0.42,0,0,1])
	    });

		// Arbitrage

// 		x="704.3"
// width="527"
// x="1004.3"
// width="227"
// x="396.5"
// width="333.9"
// x="1034.9"
// width="196.4"

		$(this).find('#arbitrageSVG #rect1')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '527',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#arbitrageSVG #rect2')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '227',
	      	}, 1000, [0.42,0,0,1])
	    $(this).find('#arbitrageSVG #rect3')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '333.9',
	      	}, 1400, [0.42,0,0,1])
	    $(this).find('#arbitrageSVG #rect4')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '196.4',
	      	}, 1600, [0.42,0,0,1])

			$(this).find('#arbitrageSVG-en #rect1')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '351.1',
		      	}, 600, [0.42,0,0,1])
		    $(this).find('#arbitrageSVG-en #rect2')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '266',
		      	}, 1000, [0.42,0,0,1])
		    $(this).find('#arbitrageSVG-en #rect3')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '193.4',
		      	}, 1400, [0.42,0,0,1])

	    // Concurrence

	    $(this).find('#concurrenceSVG #rect1')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '555.6',
	      	},800, [0.42,0,0,1])
	    $(this).find('#concurrenceSVG #rect2')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '628.6',
	      	}, 1600, [0.42,0,0,1])
	    $(this).find('#concurrenceSVG #rect3')
			.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '569.7',
	      	}, 1200, [0.42,0,0,1])


			$(this).find('#concurrenceSVG-en #rect1')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '555.6',
		      	},800, [0.42,0,0,1]);
		    $(this).find('#concurrenceSVG-en #rect2')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '498.2',
		      	}, 1600, [0.42,0,0,1]);
		    $(this).find('#concurrenceSVG-en #rect3')
				.velocity({
					'width': '0',
				}, 0)
		      	.velocity({
		      		'width': '569.7',
		      	}, 1200, [0.42,0,0,1]);

	    // Fiscal

	    $(this).find('#fiscalSVG #path1')
	      	.velocity({
	      		'translateX': '20px',
	      		'translateY': '60px',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#fiscalSVG #path2')
	      	.velocity({
	      		'translateX': '10px',
	      		'translateY': '60px',
	      	},800, [0.42,0,0,1])
	    $(this).find('#fiscalSVG #path3')
	      	.velocity({
	      		'translateX': '5px',
	      		'translateY': '60px',
	      	}, 1000, [0.42,0,0,1])
	    $(this).find('#fiscalSVG #path4')
	      	.velocity({
	      		'translateX': '-5px',
	      		'translateY': '-60px',
	      	}, 1200, [0.42,0,0,1])
	    $(this).find('#fiscalSVG #path5')
	      	.velocity({
	      		'translateX': '-10px',
	      		'translateY': '-60px',
	      	}, 1400, [0.42,0,0,1])
	    $(this).find('#fiscalSVG #path6')
	      	.velocity({
	      		'translateX': '-20px',
	      		'translateY': '-60px',
	      	}, 1600, [0.42,0,0,1])

	    // Iran Desk

	    $(this).find('#iranSVG rect')
	      	.velocity({
				'width': '0',
	      		'x': '4.9',
			}, 0)
	      	.velocity({
	      		'width': '533.2',
	      		'x': '4.9',
	      	},800, [0.42,0,0,1])

	    // Transport

		$(this).find('#transportSVG .rect1')
	      	.velocity({
				'height': 0,
				'y': '881',
			}, 0)
	      	.velocity({
	      		'height': '346.9',
	      		'y': '495',
	      	},1600, [0.42,0,0,1])
	    $(this).find('#transportSVG .rect2')
	      	.velocity({
				'height': 0,
			}, 0)
	      	.velocity({
	      		'height': '344.1',
	      	},1600, [0.42,0,0,1])

	    // Armement

	    $(this).find('#armementSVG #rect1')
	      	.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '652.5',
	      	}, 1000, [0.42,0,0,1])
	    $(this).find('#armementSVG #rect2')
	      	.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
	      		'width': '652.5',
	      	}, 1600, [0.42,0,0,1])


	    // Energy

	    $(this).find('#energySVG #path1')
	      	.velocity({
				'translateX': '-70px',
			}, 1600, [0.42,0,0,1])

	    $(this).find('#energySVG #path2')
	      	.velocity({
				'translateX': '70px',
			}, 1600, [0.42,0,0,1])


		// Security

	    $(this).find('#securitySVG rect')
	      	.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
				'width': '100.1',
	      	}, 1000, [0.42,0,0,1])


	    // Technology

	    $(this).find('#technologieSVG #path1')
	      	.velocity({
				'translateY': '-30px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#technologieSVG #path2')
	      	.velocity({
				'translateY': '-5px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#technologieSVG #path3')
	      	.velocity({
				'translateY': '-20px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#technologieSVG #path4')
	      	.velocity({
				'translateY': '-50px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#technologieSVG #path5')
	      	.velocity({
				'translateY': '-10px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])
	    $(this).find('#technologieSVG #path6')
	      	.velocity({
				'translateY': '-20px',
			}, 1600, [0.42,0,0,1])
	      	.velocity({
	      		'translateY': '0',
	      	}, 600, [0.42,0,0,1])

	    // Lobbying

	    $(this).find('#lobbyingSVG #path1')
	      	.velocity({
				'translateY': '45px',
			}, 1600, [0.42,0,0,1])

	    $(this).find('#lobbyingSVG #path2')
	      	.velocity({
				'translateY': '-55px',
			}, 1600, [0.42,0,0,1])


		// Public

		$(this).find('#publicSVG #rect1')
	      	.velocity({
				'x': '418',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '237.3',
				'width': '362.9',
	      	}, 1600, [0.42,0,0,1])
	    $(this).find('#publicSVG #rect2')
	      	.velocity({
				'x': '400',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '6.6',
				'width': '829.9',
	      	},800, [0.42,0,0,1])
	    $(this).find('#publicSVG #rect3')
	      	.velocity({
				'x': '420',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '6.6',
				'width': '829.1',
	      	}, 1200, [0.42,0,0,1])


			$(this).find('#publicSVG-en #rect1')
				.velocity({
					'x': '543',
					'width': '0',
				}, 0)
				.velocity({
					'x': '359.4',
					'width': '369.2',
				}, 1600, [0.42,0,0,1])
			$(this).find('#publicSVG-en #rect2')
				.velocity({
					'x': '550',
					'width': '0',
				}, 0)
				.velocity({
					'x': '234.5',
					'width': '619.6',
				},800, [0.42,0,0,1])
			$(this).find('#publicSVG-en #rect3')
				.velocity({
					'x': '550',
					'width': '0',
				}, 0)
				.velocity({
					'x': '198.1',
					'width': '691.7',
				}, 1200, [0.42,0,0,1])



	    // Action

	    $(this).find('#actionSVG rect')
	      	.velocity({
				'x': '392.3',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '2.8',
				'width': '392.3',
	      	}, 1600, [0.42,0,0,1])

			$(this).find('#actionSVG-en rect')
				.velocity({
					'width': '0',
				}, 0)
				.velocity({
					'width': '291.5',
				}, 1600, [0.42,0,0,1])


	    // Compliance

	    $(this).find('#complianceSVG #rect1')
	      	.velocity({
				'x': '100',
				'y': '100',
				'width': '600',
				'height': '650'
			}, 1600, [0.42,0,0,1])


		// Luxe

	    $(this).find('#luxeSVG #rect1')
	      	.velocity({
				'x': '50',
				'y': '60',
				'width': '750',
				'height': '750'
			}, 1600, [0.42,0,0,1])


			$(this).find('#luxeSVG-en #rect1')
		      	.velocity({
					'x': '160',
					'y': '50',
					'width': '750',
					'height': '750'
				}, 1600, [0.42,0,0,1])



				// x="199.1" y="11.4"
				// width="689.9" height="819.5"

		// Digital

		$(this).find('#digitalSVG #rect1')
	      	.velocity({
	      		'y': '470',
				'height': '0',
			}, 0)
	      	.velocity({
	      		'y': '0' ,
				'height': '470',
	      	}, 2400, [0.42,0,0,1])

	    $(this).find('#digitalSVG #rect2')
	      	.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
				'width': '592',
	      	}, 2400, [0.42,0,0,1])


	    // Défense

	    $(this).find('#defenseSVG #rect1')
	      	.velocity({
	      		'x':'314.1',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x':'5.4',
				'width': '314.1',
	      	}, 1600, [0.42,0,0,1])

	    $(this).find('#defenseSVG #rect2')
	      	.velocity({
				'width': '0',
			}, 0)
	      	.velocity({
				'width': '314.1',
	      	}, 1600, [0.42,0,0,1])


			$(this).find('#defenseSVG-en #rect1')
				.velocity({
					'x':'962.1',
					'width': '0',
				}, 0)
				.velocity({
					'x':'666',
					'width': '296.1',
				}, 1600, [0.42,0,0,1])

			$(this).find('#defenseSVG-en #rect2')
				.velocity({
					'width': '0',
				}, 0)
				.velocity({
					'width': '296.1',
				}, 1600, [0.42,0,0,1])


	    // Assurance

	    $(this).find('#assuranceSVG #rect1')
	      	.velocity({
				'y': '300',
				'height': '0',
			}, 0)
	      	.velocity({
	      		'y': '0',
				'height': '101.3',
	      	}, 1200, [0.42,0,0,1])

	    $(this).find('#assuranceSVG #rect2')
	      	.velocity({
				'y': '550',
				'height': '0',
			}, 0)
	      	.velocity({
	      		'y': '740.7',
				'height': '101.3',
	      	}, 1200, [0.42,0,0,1])

	    $(this).find('#assuranceSVG #rect3')
	      	.velocity({
				'x': '550',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '740.6',
				'width': '101.3',
	      	}, 1200, [0.42,0,0,1])

	    $(this).find('#assuranceSVG #rect4')
	      	.velocity({
				'x': '300',
				'width': '0',
			}, 0)
	      	.velocity({
	      		'x': '0',
				'width': '101.3',
	      	}, 1200, [0.42,0,0,1])

			$(this).find('#assuranceSVG-en #rect1')
				.velocity({
					'y': '300',
					'height': '0',
				}, 0)
				.velocity({
					'y': '0',
					'height': '101.3',
				}, 1200, [0.42,0,0,1])

			$(this).find('#assuranceSVG-en #rect2')
				.velocity({
					'y': '550',
					'height': '0',
				}, 0)
				.velocity({
					'y': '740.7',
					'height': '101.3',
				}, 1200, [0.42,0,0,1])

			$(this).find('#assuranceSVG-en #rect3')
				.velocity({
					'x': '427',
					'width': '0',
				}, 0)
				.velocity({
					'x': '740.6',
					'width': '101.3',
				}, 1200, [0.42,0,0,1])

			$(this).find('#assuranceSVG-en #rect4')
				.velocity({
					'x': '177',
					'width': '0',
				}, 0)
				.velocity({
					'x': '0',
					'width': '101.3',
				}, 1200, [0.42,0,0,1])



				$(this).find('#santeSVG-en #rect1')
				.velocity({
					'x': '300',
					'width': '0',
				}, 0)
				.velocity({
					'x': '681.5',
					'width': '150.8',
				}, 1200, [0.42,0,0,1])


				$(this).find('#santeSVG-en #rect2')
				.velocity({
					'y': '300',
					'height': '0',
				}, 0)
				.velocity({
					'y': '199.7',
					'height': '150.8',
				}, 1200, [0.42,0,0,1])

				$(this).find('#santeSVG-en #rect3')
				.velocity({
					'x': '300',
					'width': '0',
				}, 0)
				.velocity({
					'x': '123',
					'width': '150.8',
				}, 1200, [0.42,0,0,1])

				$(this).find('#santeSVG-en #rect4')
				.velocity({
					'y': '300',
					'height': '0',
				}, 0)
				.velocity({
					'y': '491.4',
					'height': '150.8',
				}, 1200, [0.42,0,0,1])

	});

	knowledgeAnimation.mouseleave(function() {
		$(this).find('#fiscalSVG .path-to-animate')
	      	.velocity({
	      		'translateX': '0',
	      		'translateY': '0',
	      	}, 1600, [0.42,0,0,1])

	    $(this).find('#lobbyingSVG .path-to-animate')
	      	.velocity({
	      		'translateX': '0',
	      		'translateY': '0',
	      	}, 1600, [0.42,0,0,1])

		$(this).find('#santeSVG .top')
	    .velocity({
    		translateY: 0
    	}, {duration:500}, [0.42,0,0,1])

    	$(this).find('#santeSVG .bottom')
	    .velocity({
    		translateY: 0
    	}, {duration:500}, [0.42,0,0,1])


    	$(this).find('#complianceSVG #rect1').velocity({
	      		'x': '7.1',
	      		'y': '7.3',
				'width': '826.5',
				'height': '825.3'
	      	}, 1600, [0.42,0,0,1])

    	$(this).find('#luxeSVG #rect1').velocity({
	      		'x': '76.1',
	      		'y': '11.4',
				'width': '689.9',
				'height': '819.5'
	      	}, 1600, [0.42,0,0,1])

			$(this).find('#luxeSVG-en #rect1').velocity({
		      		'x': '199.1',
		      		'y': '11.4',
					'width': '689.9',
					'height': '819.5'
		      	}, 1600, [0.42,0,0,1])


    	$(this).find('#energySVG #path1').velocity({
	      		'translateX': '0',
	      	}, 1000, [0.42,0,0,1])

		$(this).find('#energySVG #path2').velocity({
	      		'translateX': '0',
	      	}, 1000, [0.42,0,0,1])

	});
});
